import React, { useState } from 'react';
import { ArrowRight, Mail, Phone, MapPin } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import AnimatedSection from '../components/AnimatedSection';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! We\'ll get back to you within 24 hours.');
  };

  return (
    <div className="contact-page">
      <section className="contact-hero section-dark">
        <div className="contact-hero__bg">
          <div className="contact-hero__orb" />
        </div>
        <div className="container contact-hero__content">
          <AnimatedSection>
            <span className="label label-teal">Get in Touch</span>
            <h1>Let's Talk About <span className="text-gradient">Your Dream Home</span></h1>
            <p className="contact-hero__subtitle">
              Have questions? Want a demo? Just want to chat? We're here to help - and we typically reply within 5 minutes on WhatsApp.
            </p>
          </AnimatedSection>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <AnimatedSection direction="left">
              <div className="contact-info">
                <h3>Quick Ways to Reach Us</h3>

                <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="contact-method contact-method--whatsapp">
                  <FaWhatsapp className="contact-method__icon" />
                  <div>
                    <strong>WhatsApp (Fastest)</strong>
                    <span>+91 98765 43210</span>
                    <span className="contact-method__note">Typically reply within 5 minutes</span>
                  </div>
                </a>

                <div className="contact-method">
                  <Mail className="contact-method__icon" />
                  <div>
                    <strong>Email</strong>
                    <span>hello@sculpit.in</span>
                  </div>
                </div>

                <div className="contact-method">
                  <Phone className="contact-method__icon" />
                  <div>
                    <strong>Phone</strong>
                    <span>+91 80 4567 8900</span>
                    <span className="contact-method__note">Mon-Sat, 9am-7pm IST</span>
                  </div>
                </div>

                <div className="contact-method">
                  <MapPin className="contact-method__icon" />
                  <div>
                    <strong>Office</strong>
                    <span>Sculpit Innovations Pvt Ltd</span>
                    <span>No 17, 1st Floor, Bank of Baroda Building,</span>
                    <span>3rd Main Road, NGEF Layout, Postal Colony,</span>
                    <span>Sanjayanagara, Bengaluru 560094</span>
                  </div>
                </div>

                <div className="contact-map">
                  <iframe
                    title="Sculpit Office Location"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d242.9384383521547!2d77.57591105704972!3d13.034715796031168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1774217048146!5m2!1sen!2sin"
                    width="100%"
                    height="200"
                    style={{ border: 0, borderRadius: 'var(--radius-md)' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection direction="right">
              <form className="contact-form card-premium" onSubmit={handleSubmit}>
                <h3>Send Us a Message</h3>
                <p style={{ color: 'var(--gray-500)', fontSize: '0.9rem', marginBottom: '24px' }}>
                  Or fill out this form and we'll get back within 24 hours.
                </p>

                <div className="form-group">
                  <label>Your Name *</label>
                  <input type="text" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Full name" />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="you@example.com" />
                </div>
                <div className="form-group">
                  <label>Phone</label>
                  <input type="tel" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+91 98765 43210" />
                </div>
                <div className="form-group">
                  <label>Message *</label>
                  <textarea rows="5" required value={form.message} onChange={e => setForm({...form, message: e.target.value})} placeholder="Tell us what you're looking for..." />
                </div>
                <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', marginTop: '8px' }}>
                  Send Message <ArrowRight size={18} />
                </button>
              </form>
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
}
